export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_2240000-d348c8966819ef170ff99676fb85d92c.avif";